import PropTypes from 'prop-types';
import React from 'react';
import DashboardResourceCard from './DashboardResourceCard';
import DashboardTesTeachCard from './DashboardTesTeachCard';

var DashboardCard = function DashboardCard(props) {
  var components = {
    resource: DashboardResourceCard,
    tesTeach: DashboardTesTeachCard
  };
  var Component = components[props.cardType];
  if (!Component) return null;
  return /*#__PURE__*/React.createElement(Component, props);
};

DashboardCard.displayName = "DashboardCard";
DashboardCard.propTypes = {
  cardType: PropTypes.string.isRequired
};
export default DashboardCard;